import * as React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "../hooks";
import { isRequired } from "../hooks/useForm";
import {  PosizionamentoContext } from "../contexts";
import { useContext } from "react";
import { Search } from "@mui/icons-material";
import { MagMovimTable } from "../components";
import {  
  IconButton,
  InputAdornment,

} from "@mui/material";



const MagLogCustom = () => {
  const { codiceMenu } = useParams();
  let navigate = useNavigate();
  const inputRef = React.useRef();
  

const {
    state:{
        RicercaColumns,
        RicercaMovimenti,
        
    },
    getRicercaMagMovimentiCustom,
    getMagMovimDataCustom,
    
} = useContext(PosizionamentoContext);

  //17/10/2025 Greg: Segnalato da transmart, cambiando pagina da menudrawer la pagina non si aggiorna
  const onCodiceMenuChange = () => {
    setTimeout(() => {
      inputRef.current.focus();
    }, 100);

    getRicercaMagMovimentiCustom(codiceMenu);    
  };

  const validations = [
    ({ code }) => isRequired(code) || { code: "*Barcode obbligatorio" },
  ];

  React.useEffect(() => {
    //// non chiamo onCodiceMenuChange, altrimenti al primo accesso della pagina viene chiamato due volte
    //onCodiceMenuChange();
  }, [ ]);


  React.useEffect(() => {
    onCodiceMenuChange();
  }, [ codiceMenu ]);



  const {
    values: barcodeForm,
    changeHandler,
    touched,
    errors,
    isValid,
  } = useForm(
    {
      code: "",
      Ubicazione: '',
      CodiceArticolo: '',
    },
    validations
  );

  const onkeyEnter = (event) => {
    if (event === 13) {
      inputRef.current.blur();
      if (barcodeForm.code && isValid) {
        getMagMovimDataCustom(codiceMenu, barcodeForm.code, navigate);
      }
    }
  }; 

  return (
    <>

      <Stack direction={"row"} spacing={2} m={2}>

        <TextField
          id="outlined-basic"
          label="Barcode"
          variant="outlined"
          placeholder="Inserire il barcode"
          fullWidth
          autoFocus
          autoComplete="off"
          inputRef={inputRef}
          /* onClick={()=> inputRef.current.blur()}
              onDoubleClick={()=> inputRef.current.focus()} */
          onKeyPress={(e) => onkeyEnter(e.charCode)}
          onChange={(e) => changeHandler("code", e.target.value)}
          error={Boolean(touched.code && errors.code)}
          //helperText={touched.code && errors.code}
          value={barcodeForm.code || ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton 
                  color="primary"
                  disabled={!isValid}
                  onClick={() => onkeyEnter(13)}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>


      <MagMovimTable 
        columnsData={RicercaColumns} 
        rowsData={RicercaMovimenti} 
        navigate={navigate} 
        detailFunc={getMagMovimDataCustom} 
        detailPath={"merce-mag-log-custom-dettaglio"}
        codiceMenu  = {codiceMenu}
      />
              

    </>
  );
};
export default MagLogCustom;